import {
  FlexRow,
  MaterialIcon,
  StyledButton,
  StyledSearchBar,
  useDebouncedSearch,
  useModal,
} from '@gorila-shared-ui/components';
import { Button } from 'baseui/button';
import { useEffect } from 'react';
import { useRecoilState, useResetRecoilState } from 'recoil';
import { useStyles } from '../../../../hooks/useStyles';
import { subClientsSearchFilterState } from '../../../../storage/subClients';
import NewSubClientModal from '../../../subClient/modal/NewSubClientModal';
import EnhancedLabeledSelect from '../../../ui/EnhancedLabeledSelect';
import StyledTooltip from '../../../ui/StyledTooltip';

type Props = {
  clientId: string;
  onReloadPage: () => void;
  activeOnly?: boolean;
  setActiveOnly: (activeOnly?: boolean) => void;
};

export function ClientSubClientFiltersBar({ clientId, onReloadPage, activeOnly, setActiveOnly }: Readonly<Props>) {
  const { css, theme } = useStyles();
  const { openModal: openFormModal, closeModal: closeFormModal, showModal: showFormModal } = useModal();
  const { search, setSearch } = useDebouncedSearch(useRecoilState(subClientsSearchFilterState));
  const resetSearch = useResetRecoilState(subClientsSearchFilterState);

  const resetFilters = () => {
    resetSearch();
    setActiveOnly(true);
  };

  useEffect(() => {
    return () => {
      resetFilters();
    };
  }, []);

  return (
    <FlexRow
      classNames={css({
        justifyContent: 'space-between',
        width: '100%',
      })}
    >
      <FlexRow
        gap={theme.sizing.scale300}
        classNames={css({
          width: '70%',
        })}
      >
        <FlexRow
          classNames={css({
            width: '60%',
          })}
        >
          <StyledSearchBar
            value={search ?? ''}
            onChange={setSearch}
            clearable
            noMargin
          />
        </FlexRow>
        <EnhancedLabeledSelect
          label="Estado:"
          options={[
            { id: undefined, label: 'Todos' },
            { id: 'true', label: 'Activo' },
            { id: 'false', label: 'Inactivo' },
          ]}
          value={[{ id: activeOnly === undefined ? undefined : `${activeOnly}` }]}
          onChange={(params) => setActiveOnly(params.option?.id ? params.option.id === 'true' : undefined)}
          inline
          inset
        />
        <StyledTooltip
          content="Restaurar filtros"
          showArrow={false}
        >
          <Button
            size="compact"
            shape="square"
            onClick={resetFilters}
            kind="tertiary"
          >
            <MaterialIcon name="autorenew" />
          </Button>
        </StyledTooltip>
      </FlexRow>
      <FlexRow gap={theme.sizing.scale300}>
        <StyledTooltip
          content={'Recargar tabla'}
          showArrow={false}
        >
          <Button
            size="compact"
            shape="square"
            onClick={onReloadPage}
            kind="tertiary"
          >
            <MaterialIcon name={'refresh'} />
          </Button>
        </StyledTooltip>
        <StyledButton
          onClick={openFormModal}
          startEnhancer={
            <MaterialIcon
              name="add"
              size="xs-mini"
              color={theme.colors.contentInversePrimary}
            />
          }
        >
          Nuevo
        </StyledButton>
      </FlexRow>
      {showFormModal && (
        <NewSubClientModal
          clientId={clientId}
          onClose={(updateTable) => {
            if (updateTable) {
              onReloadPage();
            }
            closeFormModal();
          }}
          isOpen={showFormModal}
        />
      )}
    </FlexRow>
  );
}
